import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Login from "./pages/Login";
import DashboardLayout from "./DashboardLayout";
import BvnCount from "./pages/BvnCount";
import BvnLogs from "./pages/BvnLogs";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Navigate to="/login" replace />,
    },
    {
      path: "/login",
      element: <Login />,
    },

    {
      path: "/dashboard",
      element: <DashboardLayout />,
      children: [
        { index: true, element: <BvnCount /> },
        {
          path: "bvn_count",
          element: <BvnCount />,
        },
        {
          path: "bvn_logs",
          element: <BvnLogs />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
